module.exports = __webpack_public_path__ + "img/Butterfly_00204.534335fb.png";